(function () {
  const FORM_SELECTOR = '#FacetFiltersForm';
  const FILTER_SELECTOR = '.js-filter';
  const BUTTON_SELECTOR = '.facets__summary';
  const CONTENT_SELECTOR = '[x-show="open"]';

  let firstFilterOpened = false;

  /*
    Mappa stabile IT/EN.
    Il testo visibile può cambiare con T LAB,
    ma la classe generata resta sempre stabile.
  */
  const FILTER_SLUG_MAP = {
    // Categoria
    'categoria': 'categoria',
    'category': 'categoria',
    'categories': 'categoria',

    // Genere
    'genere': 'genere',
    'gender': 'genere',

    // Disciplina
    'disciplina': 'disciplina',
    'discipline': 'disciplina',

    // Tipologia
    'tipologia': 'tipologia',
    'type': 'tipologia',
    'types': 'tipologia',
    'product type': 'tipologia',
    'product types': 'tipologia',

    // Materiale
    'materiale': 'materiale',
    'material': 'materiale',
    'materials': 'materiale',

    // Utilizzo
    'utilizzo': 'utilizzo',
    'uso': 'utilizzo',
    'use': 'utilizzo',
    'usage': 'utilizzo',

    // Brand
    'brand': 'brand',
    'marca': 'brand',
    'marchio': 'brand',
    'vendor': 'brand',

    // Diametro
    'diametro': 'diametro',
    'diameter': 'diametro',

    // Spessore
    'spessore': 'spessore',
    'thickness': 'spessore',

    // Peso
    'peso': 'peso',
    'weight': 'peso',

    // Prezzo
    'prezzo': 'prezzo',
    'price': 'prezzo',
    'prices': 'prezzo'
  };

  /*
    Mappa tecnica.
    Prima prova a leggere valori stabili da input/name/data-attribute.
    Se li trova, non usa il titolo visibile tradotto.
  */
  const TECHNICAL_FILTER_MAP = [
    {
      slug: 'categoria',
      keywords: ['custom.categoria', 'filter.p.m.custom.categoria', 'categoria']
    },
    {
      slug: 'genere',
      keywords: ['custom.genere', 'filter.p.m.custom.genere', 'genere']
    },
    {
      slug: 'disciplina',
      keywords: ['custom.disciplina', 'filter.p.m.custom.disciplina', 'disciplina']
    },
    {
      slug: 'tipologia',
      keywords: ['custom.tipologia', 'filter.p.m.custom.tipologia', 'tipologia', 'product_type', 'product-type']
    },
    {
      slug: 'materiale',
      keywords: ['custom.materiale', 'filter.p.m.custom.materiale', 'materiale']
    },
    {
      slug: 'utilizzo',
      keywords: ['custom.utilizzo', 'filter.p.m.custom.utilizzo', 'utilizzo']
    },
    {
      slug: 'brand',
      keywords: ['filter.p.vendor', 'vendor', 'brand', 'marca', 'marchio']
    },
    {
      slug: 'diametro',
      keywords: ['custom.diametro', 'filter.p.m.custom.diametro', 'diametro', 'diameter']
    },
    {
      slug: 'spessore',
      keywords: ['custom.spessore', 'filter.p.m.custom.spessore', 'spessore', 'thickness']
    },
    {
      slug: 'peso',
      keywords: ['custom.peso', 'filter.p.m.custom.peso', 'peso', 'weight']
    },
    {
      slug: 'prezzo',
      keywords: ['filter.v.price', 'filter.price', 'price', 'prezzo']
    }
  ];

  function slugifyFilterName(text) {
    return String(text || '')
      .replace(/\s*\([^)]*\)/g, '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function normalizeFilterLabel(text) {
    return String(text || '')
      .replace(/\s*\([^)]*\)/g, '')
      .replace(/^filter by\s+/i, '')
      .replace(/^filtra per\s+/i, '')
      .replace(/^filtra\s+/i, '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function getFilterName(button) {
    if (!button) return '';

    const titleSpan = button.querySelector('span.text-medium');

    if (titleSpan && titleSpan.textContent.trim()) {
      return titleSpan.textContent;
    }

    const ariaLabel = button.getAttribute('aria-label');

    if (ariaLabel) {
      return ariaLabel;
    }

    return '';
  }

  function getTechnicalFilterSlug(filter) {
    if (!filter) return '';

    const technicalValues = [];

    filter.querySelectorAll('input[name], select[name], textarea[name]').forEach(function (field) {
      technicalValues.push(field.getAttribute('name'));
    });

    filter.querySelectorAll('[data-filter-param], [data-filter-name], [data-index], [data-name]').forEach(function (element) {
      technicalValues.push(element.getAttribute('data-filter-param'));
      technicalValues.push(element.getAttribute('data-filter-name'));
      technicalValues.push(element.getAttribute('data-index'));
      technicalValues.push(element.getAttribute('data-name'));
    });

    const technicalText = technicalValues
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    if (!technicalText) return '';

    for (const item of TECHNICAL_FILTER_MAP) {
      const hasMatch = item.keywords.some(function (keyword) {
        return technicalText.includes(keyword.toLowerCase());
      });

      if (hasMatch) {
        return item.slug;
      }
    }

    return '';
  }

  function getStableFilterSlug(filter, button) {
    const technicalSlug = getTechnicalFilterSlug(filter);

    if (technicalSlug) {
      return technicalSlug;
    }

    const filterName = getFilterName(button);
    const normalizedLabel = normalizeFilterLabel(filterName);

    if (FILTER_SLUG_MAP[normalizedLabel]) {
      return FILTER_SLUG_MAP[normalizedLabel];
    }

    return slugifyFilterName(filterName);
  }

  function isVisible(element) {
    if (!element) return false;

    const style = window.getComputedStyle(element);

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      element.getClientRects().length > 0
    );
  }

  function isFilterOpen(filter) {
    const content = filter.querySelector(CONTENT_SELECTOR);

    if (!content) return false;

    const style = window.getComputedStyle(content);

    return (
      !content.hasAttribute('hidden') &&
      style.display !== 'none' &&
      content.offsetHeight > 0
    );
  }

  function addFilterClasses() {
    const forms = document.querySelectorAll(FORM_SELECTOR);

    forms.forEach(function (form) {
      const filters = form.querySelectorAll(FILTER_SELECTOR);

      filters.forEach(function (filter) {
        const button = filter.querySelector(BUTTON_SELECTOR);

        if (!button) return;

        const slug = getStableFilterSlug(filter, button);

        if (!slug) return;

        const wrapperClassName = 'filtro-' + slug;
        const buttonClassName = 'filtro-' + slug + '-button';

        filter.classList.add(wrapperClassName);
        button.classList.add(buttonClassName);
      });
    });
  }

  function openFirstVisibleFilter() {
    if (firstFilterOpened) return;

    const form = document.querySelector(FORM_SELECTOR);
    if (!form) return;

    const filters = Array.from(form.querySelectorAll(FILTER_SELECTOR));

    const firstVisibleFilter = filters.find(function (filter) {
      return isVisible(filter);
    });

    if (!firstVisibleFilter) return;

    if (isFilterOpen(firstVisibleFilter)) {
      firstFilterOpened = true;
      return;
    }

    const button = firstVisibleFilter.querySelector(BUTTON_SELECTOR);
    if (!button) return;

    firstFilterOpened = true;
    button.click();
  }

  function run() {
    addFilterClasses();

    setTimeout(function () {
      addFilterClasses();
      openFirstVisibleFilter();
    }, 700);
  }

  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);

  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:select', run);

  const observer = new MutationObserver(function () {
    addFilterClasses();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();